module.exports = __webpack_public_path__ + "static/media/16.ca880015.jpg";